<ng-container *ngIf="(CartDetails$ | async) as CartDetails">
  <ng-container *ngIf="nextSaveStep > 0 && CartDetails.Courses.size < 10">
    Add {{coursesLeftToAdd}} more course{{coursesLeftToAdd == 1 ? '' : 's'}} to save ${{nextSaveStep}}
  </ng-container>
  <ng-container *ngIf="CartDetails.Courses.size >= 10">
    <ng-container *ngIf="CartDetails.Total <= 199">
      For just ${{(199 - CartDetails.Total)}} more, membership gives you these and 200+ other courses
    </ng-container>
    <ng-container *ngIf="CartDetails.Total > 199">
      Get 200+ hours of CE and save ${{(CartDetails.Total - 199)}} with a $199 membership
    </ng-container>
</ng-container>
